export default {
  author: APP_ENV.author,
  api: APP_ENV.endpoint,
  title: APP_ENV.title,
  hashcode: APP_ENV.hashcode,
  version: APP_ENV.version,
  prefix: APP_ENV.prefix,
  timestamp: APP_ENV.timestamp,
}
